export default "__VITE_ASSET__zvE7idAk__"